import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';

import Footer from '../components/Footer';
import { getProjects } from '../data/projects';

const FILTERS = [
  { key: 'all',          label: 'Tous' },
  { key: 'identite',     label: 'Identité Visuelle' },
  { key: 'ui',           label: 'UI / UX' },
  { key: 'motion',       label: 'Motion Design' },
  { key: 'print',        label: 'Print' },
  { key: 'illustration', label: 'Illustration' },
];

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Portfolio — HEYIMPURP';
    setProjects(getProjects());
  }, []);

  const filtered = activeFilter === 'all'
    ? projects
    : projects.filter(p => p.cat === activeFilter);

  return (
    <>
      <Nav />

      <div className="page-header">
        <div className="page-label">Portfolio</div>
        <h1 className="page-title">MES<br />PROJETS</h1>
        <p className="page-subtitle">Une sélection de travaux en identité visuelle, direction artistique, UI design et print.</p>
      </div>

      <div className="filters">
        {FILTERS.map(f => (
          <button
            key={f.key}
            className={`filter-btn${activeFilter === f.key ? ' active' : ''}`}
            onClick={() => setActiveFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <section className="projects-section">
        <div className="projects-grid">
          {filtered.map(p => {
            const hasImg = p.image && p.image.trim() !== '';
            return (
              <div
                key={p.id}
                className="project-card"
                data-cat={p.cat}
                onClick={() => navigate(`/projet/${p.id}`)}
              >
                {hasImg
                  ? <img src={p.image} alt={p.name} className="project-img" />
                  : (
                    <div className={`project-visual ${p.bg || 'project-bg-1'}`}>
                      <div className="project-visual-inner">{p.letter || p.name[0]}</div>
                    </div>
                  )
                }
                <div className="project-overlay">
                  <div className="project-cat">{p.catLabel}</div>
                  <div className="project-name">{p.name}</div>
                  <p className="project-desc">{p.desc}</p>
                </div>
                <div className="project-arrow">→</div>
              </div>
            );
          })}
        </div>
        <div className="load-more-wrap">
          <button className="btn-outline">Voir plus de projets</button>
        </div>
      </section>

      <Footer />
    </>
  );
}
